// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconStar = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 25 25', fill: 'none', ...props },
    <path
      d="M18.89 24.02c-.24 0-.48-.05-.7-.17L12 20.78l-6.19 3.06c-.54.27-1.21.2-1.68-.19-.48-.39-.68-1.02-.53-1.61l1.85-6.72-4.99-4.94a1.58 1.58 0 01-.37-1.64c.21-.57.73-.97 1.33-1.02l6.02-.6L10.6.86C10.87.33 11.41 0 12 0c.59 0 1.13.33 1.4.85l3.16 6.26 6.03.6c.59.05 1.11.45 1.32 1.02.21.57.06 1.21-.37 1.64l-4.99 4.94 1.85 6.71c.16.6-.05 1.23-.52 1.62-.28.26-.63.38-.99.38zM12 19.2c.11 0 .23.03.33.08l6.53 3.23.82-.26-.72.2L17 15.31c-.07-.26 0-.54.2-.73l5.3-5.25s-.04-.09-.05-.09l-6.44-.64a.767.767 0 01-.6-.41l-3.35-6.63a.068.068 0 00-.06-.04L8.6 8.18c-.12.23-.34.38-.6.41l-6.44.64-.57.63.53-.53 5.3 5.25c.19.19.27.47.2.73l-1.97 7.14.09.06 6.52-3.23c.11-.05.23-.08.34-.08z"
      fill="currentColor"
    />
  );
export default SvgIconStar;
